import React from 'react';
import { useParams } from 'react-router-dom';
import { TypedMemo } from '../../common/types';
import { LoadingView } from '../../common/views/LoadingView';
import { useAccountId } from '../../../redux/slices/appInfo/hooks';
import { StreamingSection } from './streamingPaths';
import { StreamingScreen } from './StreamingScreen';

interface StreamingViewProps {
  section: StreamingSection;
}

/**
 * The Streaming routes (design your-intelligence h4): `/streaming`, `/streaming/tracks`,
 * `/streaming/tracks/:trackId`, `/streaming/stores`, `/streaming/countries`,
 * `/streaming/playlists`, `/streaming/earnings`, and the period sections `/streaming/audience`,
 * `/streaming/playSources`, `/streaming/shortVideo` and `/streaming/accelerator`. Every read is for
 * one artist, so the screen mounts once the selected artist is known.
 */
const StreamingViewComponent: React.FC<StreamingViewProps> = ({ section }) => {
  const accountId = useAccountId();
  const { trackId } = useParams<{ trackId?: string }>();

  if (accountId === null) {
    return <LoadingView />;
  }

  return <StreamingScreen accountId={accountId} section={section} trackKey={trackId} />;
};

export const StreamingView = TypedMemo(StreamingViewComponent);
